import {
  ADD_LIST,
  FETCH_LIST,
  SET_LOADING,
} from '@/store/actions/driverWelcomePage'
import { RepositoryFactory } from '@/api/RepositoryFactory'

const welcomePageAPI = RepositoryFactory.get('welcomePage')

export default {
  namespaced: true,
  state: {
    lists: [],
    loading: true,
  },
  getters: {
    getList: state => state.lists,
    getLoadingList: state => state.loading,
  },
  mutations: {
    [ADD_LIST]: (state, payload) => (state.lists = payload.items),
    [SET_LOADING]: (state, payload) => (state.loading = payload),
  },
  actions: {
    async [FETCH_LIST]({ commit }, params = {}) {
      commit(SET_LOADING, false)
      await welcomePageAPI.getListBid(params).then(response => {
        commit(SET_LOADING, false)
        commit(ADD_LIST, response.data)
      })
    },
  },
}
